import React from 'react';

import { Box, Button, Collapse } from '@mui/material';

import { classes } from './styles';

import type { TableActionDrawerAction } from './types';

export interface DrawerActionItem {
  id: string;
  label: string;
  icon: React.JSX.Element;
}

const ItemActionsDrawer = ({
  drawerOpen,
  dispatch,
  actions,
  label
}: {
  drawerOpen: boolean;
  dispatch: React.Dispatch<TableActionDrawerAction>;
  actions: DrawerActionItem[];
  label: string;
}) => (
  <Collapse in={drawerOpen}>
    <Box sx={classes.actionsContianer}>
      {actions.map((action) => (
        <Button
          key={action.id}
          id={`${action.id}-action-${label}-button`}
          startIcon={action.icon}
          sx={classes.actionButton}
          variant="outlined"
          onClick={() =>
            dispatch({
              type: 'SET_ACTION_MODAL_OPEN',
              payload: { name: action.id, isOpen: true }
            })
          }
        >
          {action.label}
        </Button>
      ))}
    </Box>
  </Collapse>
);

export default ItemActionsDrawer;
